import React from 'react'

import { connect } from 'react-redux'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { Container, Card } from 'react-bootstrap'

import { userCan } from 'src/store/user/userActions'
import { useQuery, route } from 'src/utils/routes'
import { IState } from 'src/store'

import Error401 from 'src/pages/Error/401.page'
import Header from 'src/components/Layout/Header/Header'
import MerchandiserForm from 'src/components/Merchandiser/MerchandiserForm'

interface IProps extends RouteComponentProps {
  history: any
  user: any
  userCan: (permission: string) => boolean
}

const MerchandiserSignup: React.FC<IProps> = ({ history, user, userCan }) => {
  const name = useQuery().get('name')
  const phone = useQuery().get('phone')

  if (!userCan('signup_merchandiser')) return <Error401 />

  return (
    <>
      <Header
        title="New Merchandiser"
        backText="Merchandisers"
        onBack={() => history.push(route('merchandisers'))}
      />
      <div className="page-container">
        <Container>
          <Card>
            <Card.Header>
              <Card.Title>Merchandiser Details</Card.Title>
            </Card.Header>
            <Card.Body className="pt-0">
              <MerchandiserForm
                user={user}
                phonePrefill={phone}
                namePrefill={name}
              />
            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  )
}

export default connect((state: IState) => ({ user: state.user }), { userCan })(
  withRouter(MerchandiserSignup)
)
